'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';
import AnalyticsDashboard from './AnalyticsDashboard';
import ContentManager from './ContentManager';
import AIConfiguration from './AIConfiguration';
import MonitoringDashboard from './MonitoringDashboard';
import LiveActivityFeedAdmin from './LiveActivityFeedAdmin';
import SMSNotificationAdmin from './SMSNotificationAdmin';
import SupportTicketAdmin from './SupportTicketAdmin';
import ReviewsManagement from './ReviewsManagement';
import EnhancedAnalyticsDashboard from './EnhancedAnalyticsDashboard';
import FeedbackSurveyAdmin from './FeedbackSurveyAdmin';
import SystemHealthMonitor from './SystemHealthMonitor';
import DataBackupsAdmin from './DataBackupsAdmin';
import PerformanceAnalyticsAdmin from './PerformanceAnalyticsAdmin';

type TabType = 'analytics' | 'enhanced-analytics' | 'content' | 'ai-config' | 'monitoring' | 'live-feed' | 'sms' | 'support' | 'reviews' | 'feedback' | 'system-health' | 'data-backups' | 'performance';

const AdminInteractive = () => {
  const [activeTab, setActiveTab] = useState<TabType>('analytics');

  const tabs = [
    { id: 'analytics' as TabType, label: 'Analytics', icon: 'ChartBarIcon' },
    { id: 'enhanced-analytics' as TabType, label: 'Deep Analytics', icon: 'PresentationChartLineIcon' },
    { id: 'feedback' as TabType, label: 'Feedback', icon: 'StarIcon' },
    { id: 'live-feed' as TabType, label: 'Live Feed', icon: 'SignalIcon' },
    { id: 'support' as TabType, label: 'Support Tickets', icon: 'ChatBubbleLeftRightIcon' },
    { id: 'reviews' as TabType, label: 'Reviews', icon: 'StarIcon' },
    { id: 'sms' as TabType, label: 'SMS Alerts', icon: 'BellIcon' },
    { id: 'content' as TabType, label: 'Content', icon: 'DocumentTextIcon' },
    { id: 'ai-config' as TabType, label: 'AI Config', icon: 'CpuChipIcon' },
    { id: 'monitoring' as TabType, label: 'Monitoring', icon: 'SignalIcon' },
    { id: 'system-health' as TabType, label: 'System Health', icon: 'ServerIcon' },
    { id: 'data-backups' as TabType, label: 'Data Backups', icon: 'CircleStackIcon' },
    { id: 'performance' as TabType, label: 'Performance', icon: 'BoltIcon' },
  ];

  return (
    <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="mb-8">
        <h1 className="font-heading text-4xl md:text-5xl font-black text-foreground mb-2">Admin Dashboard</h1>
        <p className="text-lg text-muted-foreground">Manage your AI-powered travel platform</p>
      </div>

      <div className="bg-white rounded-lg shadow-brand mb-8 border border-border">
        <div className="flex flex-wrap border-b border-border overflow-x-auto">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center gap-2 px-5 py-4 font-bold transition-all duration-200 whitespace-nowrap ${
                activeTab === tab.id
                  ? 'text-primary border-b-2 border-primary bg-primary/5' :'text-muted-foreground hover:text-foreground hover:bg-surface'
              }`}
            >
              <Icon name={tab.icon as any} size={18} />
              <span>{tab.label}</span>
            </button>
          ))}
        </div>
        <div className="p-6">
          {activeTab === 'analytics' && <AnalyticsDashboard />}
          {activeTab === 'enhanced-analytics' && <EnhancedAnalyticsDashboard />}
          {activeTab === 'feedback' && <FeedbackSurveyAdmin />}
          {activeTab === 'live-feed' && <LiveActivityFeedAdmin />}
          {activeTab === 'support' && <SupportTicketAdmin />}
          {activeTab === 'sms' && <SMSNotificationAdmin />}
          {activeTab === 'content' && <ContentManager />}
          {activeTab === 'ai-config' && <AIConfiguration />}
          {activeTab === 'monitoring' && <MonitoringDashboard />}
          {activeTab === 'reviews' && <ReviewsManagement />}
          {activeTab === 'system-health' && <SystemHealthMonitor />}
          {activeTab === 'data-backups' && <DataBackupsAdmin />}
          {activeTab === 'performance' && <PerformanceAnalyticsAdmin />}
        </div>
      </div>
    </div>
  );
};

export default AdminInteractive;